import type { IconSvgObject } from './types';

const RubiksCubeIcon: IconSvgObject = [
  ["path", { d: "M21 12L12 17L3 12", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 7L12 2L3 7M21 7L12 12L3 7M21 7V17L12 22L3 17V7", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 22V12", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M16.5 19.5V9.5L7.5 4.5", stroke: "currentColor", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M7.5 19.5V9.5L16.5 4.5", stroke: "currentColor", strokeWidth: "1.5", key: "4" }]
];

export default RubiksCubeIcon;
